const OPEN_SUPPORT_DETAILS_MODAL =
  'supportersScreen/OPEN_SUPPORT_DETAILS_MODAL';
const CLOSE_SUPPORT_DETAILS_MODAL =
  'supportersScreen/CLOSE_SUPPORT_DETAILS_MODAL';
const SET_IS_SHOWING_HOW_SPONSORSHIPS_WORKS_MODAL =
  'supportersScreen/SET_IS_SHOWING_HOW_SPONSORSHIPS_WORKS_MODAL';

export default {
  OPEN_SUPPORT_DETAILS_MODAL,
  CLOSE_SUPPORT_DETAILS_MODAL,
  SET_IS_SHOWING_HOW_SPONSORSHIPS_WORKS_MODAL,
};
